import * as React from "react";

const TwitterIcon = (props) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title />
    <path d="M86.94 30.66a19.58 19.58 0 0 1 14 6.17s7.64-1.5 11.86-4.47c0 0-1.06 5.88-8.09 10.38h.06c.54 0 4.48-.1 10.68-3 0 0-1.19 3.39-9.3 9.84.49 15.26-7.06 43.47-35 53.51A56.36 56.36 0 0 1 52 106.52a53.69 53.69 0 0 1-29.5-8.67c1.5.15 2.85.15 4.2.15 16.52 0 24.52-8.48 24.08-8.48h-.61c-14 0-17.41-13.4-17.41-13.4a6.46 6.46 0 0 0 3.73.92 20.4 20.4 0 0 0 5-.73c-15.8-3.74-15.21-18.9-15.21-18.9a13.45 13.45 0 0 0 7.2 2.26 7 7 0 0 0 1.26-.1C20.31 48.15 29 34.52 29 34.52c16.26 18.87 36.25 19.54 39 19.54h.33c-1.48-8.86 2.17-17.37 12-22a15.35 15.35 0 0 1 6.54-1.4M122 18l-12.93 9.08a23.93 23.93 0 0 1-6.34 2.65 26.16 26.16 0 0 0-15.83-5.54 21.69 21.69 0 0 0-9.3 2c-9.18 4.31-14.76 11.75-15.87 20.68a49.25 49.25 0 0 1-27.79-16.59l-5.7-6.61-4.7 7.33a25.19 25.19 0 0 0-3.4 16.66l-.37 9.53a26.24 26.24 0 0 0 5.69 16.68l1 3.9a26.17 26.17 0 0 0 8.36 12.89 37.24 37.24 0 0 1-8.13.86c-1.19 0-2.42-.05-3.66-.15L.1 89.46l18.55 13.63A60.21 60.21 0 0 0 52 113a63 63 0 0 0 21.38-3.8 57.06 57.06 0 0 0 31.7-27.91 68.92 68.92 0 0 0 7.57-28.65c6.63-5.71 8.45-9.35 8.94-10.74l5.12-14.57-7 3.26L122 18Z" />
  </svg>
);

export default TwitterIcon;
